import React, {useState, useEffect} from 'react'
import './Family.css';

import Person from './Person'
// DB
import { db, auth } from '../utils/User/include/Authorize'
import { useStateValue } from '../utils/Provider/StateProvider';



function Family() {
    const [{ user, myfamily }, dispatch] = useStateValue();
    const [member, setMembers] = useState([])

    useEffect(() => {
        if(user){
            db.collection(user.email)
                .doc('Family')
                .collection('members')
                .onSnapshot(snapshot => {
                    const data = []
                    snapshot.forEach(doc => {
                        
                        let obj = doc.data()
                        obj['uuid'] = doc.id
                        data.push(obj)

                        dispatch({
                            type: 'MY_FAMILY',
                            myfamily: data
                        })


                    })
                })
        }
    }, [])
    
    return (
    <div className='family_card_container'>

        {myfamily ?


            <div className='family_card_container_mainDiv'>
                <div className='family_card_container_mainDiv_title'>
                    <h3>My Family</h3>
                    
                </div>
                
                <div className='family_card_container_mainDiv_people'>
                    { 
                        myfamily.map(person => (
                            <Person details={person} />
                        ))  
                    }
                </div>
                
            </div>
        :
            null
        }
        
    </div>
    )
}

export default Family